import React from "react"
import { ButtonIconSeeker } from "@ui-seeker/core"


export default function AppButtonIcon({ icon, tooltip, ...props }) {
    return <ButtonIconSeeker
		icon={icon}
		iconWeight="light"
		tooltip={tooltip}
		{...props}
		sx={{ 
			fontSize: "1.2rem",
			p: .5,
			pr: 0,
			...props?.sx
		 }}
	/>
}